import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';


// import { Store } from '@ngrx/store';

// import * as fromAuth from '../store/auth';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { CommonService } from '@app/shared/common/common.service';
import { EmitService } from '@app/ts/services/emit.service';

declare var Buffer: any;
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  encryptionKey: string;
  constructor(
    private injector: Injector,
    private commonService: CommonService,
    private emitService: EmitService,
    // public store: Store<fromAuth.AuthState>
  ) {
    this.encryptionKey = environment.encryptionKey;
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let hostName = "";
    try {
      hostName = new URL(request.url).host
    } catch (error) {
      
    }
    
    request = this.addHeader(request);
    if(hostName && environment.COOKIE_ENABLED_DOMAINS.find(domain => domain == hostName)){
      let cookieExist = this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.checkCookie)));
      if(cookieExist) {
        cookieExist = JSON.parse(cookieExist);      
        if(localStorage.getEncryptedItem('partyID')&&localStorage.getEncryptedItem('partyID')!=cookieExist['partyID']) {
          localStorage.setEncryptedItem('partyID',cookieExist['partyID'])
          localStorage.removeEncryptedItem('userData');
          location.reload();
        }
      }
      
      return this.handleApiRequest(request, next);
    }
    
    if (request.url.search(localStorage.getEncryptedItem('API_END_POINT_GATE2B')+'gate2bAPI/gate2B') === 0) {
      return this.handleApiRequest(request, next);
    } else {
      return this.handleApi(request,next);
    }
  }

  private addHeader(req: HttpRequest<any>) {

    const logParams = {}; 
    let encryptedToken: string;
    // const formData = new FormData();
    if (req.body instanceof FormData) {
      // if()
      if (!req.body.has('partyIdLog')) {
        req.body.append('partyIdLog', localStorage.getEncryptedItem('partyID'));
      }
      if (!req.body.has('accIdLog')) {
        req.body.append('accIdLog', localStorage.getEncryptedItem('accId'));
      }
      if (!req.body.has('partyId')) {
        req.body.append('partyId', localStorage.getEncryptedItem('partyID'));
      }
      if (!req.body.has('accId')) {
        req.body.append('accId', localStorage.getEncryptedItem('accId'));
      }
      if (!req.body.has('mail_host_details')) {
        req.body.append('mail_host_details', localStorage.getEncryptedItem('domain'));
      }
      // Adding condition to check the parameters have a file or binary data.
      let hasFile  = false;
      req.body.forEach((value: any) => {
        if (value instanceof File || value instanceof Blob) {
          hasFile = true;
        }
      });
      if (hasFile) {
        // Skip encryption completely, just pass through
        req =  req.clone({
          body: req.body
        })
      }
      else if (!req.body.has('encrToken')) {
        let object = this.commonService.createObject(req.body);
        let token = this.commonService.createToken(object);
        let encryptedToken = this.commonService.encrypt(token);
        const newFormData = new FormData();
        newFormData.append('encrToken', encryptedToken);

        req = req.clone({ body: newFormData });
      }
      else{
        req =  req.clone({
          body: req.body
        })
      }
      
    } else if (req.body && typeof req.body === 'object') {
    // JSON object body
    if (!req.body['encrToken']) {
      const token = this.commonService.createToken(req.body);
      encryptedToken = this.commonService.encrypt(token);
    } else {
      encryptedToken = req.body['encrToken'];
    }

    // Replace with object containing only encrToken
    req = req.clone({ body: { encrToken: encryptedToken } });

  } else {
    // Empty or undefined body — use dummy object
    const dummy = { placeholder: 'value' };
    const token = this.commonService.createToken(dummy);
    encryptedToken = this.commonService.encrypt(token);

    // Send just the encrToken
    req = req.clone({ body: { encrToken: encryptedToken } });
  }
  if(req.url.indexOf(environment.NOTIFICATION_END_POINT) == -1)
    return req.clone({
      headers: new HttpHeaders(),
      withCredentials: true
    });
    else
      return req.clone({
      headers: new HttpHeaders()
    });
  }

  handleApiRequest(request, next) {
    // let request1 = request.clone({ headers: request.headers.set('withCredentals', 'true') })
    // const handler = next.handle(request).pipe(
    //   catchError((error, caught) => {
    //     if (error.status === 401 || error.status === 403) {
    //       // let currentURL = window.location.href
    //       let currentURL =environment.GATE2B_URL[localStorage.getEncryptedItem('domain')]+'userDashboard';
    //       // window.location.href=environment.LOGIN_URL[localStorage.getEncryptedItem('domain')];
    //       // window.location.href = environment.LOGOUT_URL[localStorage.getEncryptedItem('domain')]+encodeURIComponent(this.commonService.encrypt(currentURL))

    //       // this.store.dispatch(new fromAuth.LogoutAction());
    //       return throwError(error);
    //     } else {
    //       return throwError(error);
    //     }
    //   })
    // );
    const handler = next.handle(request).pipe(
      tap(res=> {
          if (res instanceof HttpResponse) {
                 if(res.body.data=='cookie_not_found'){
                  this.emitService.subscribeapiError(true);  
                 }
                                                 
          }
      }),
      catchError((error: any) => {
        if (error.status === 401 || error.status === 403) {
          // let currentURL = window.location.href
          let currentURL = localStorage.getEncryptedItem('GATE2B_URL')+'userDashboard';
          // window.location.href=environment.LOGIN_URL[localStorage.getEncryptedItem('domain')];
          window.location.href = localStorage.getEncryptedItem('ACCOUNTS_URL')+'auth/logout/'+encodeURIComponent(this.commonService.encrypt(currentURL))

          // this.store.dispatch(new fromAuth.LogoutAction());
          return throwError(error);
        } else {
          return throwError(error);
        }
      }));
    return handler;
  }
 handleApi(request,next) {
  const handler = next.handle(request).pipe(
    tap(res=> {
        if (res instanceof HttpResponse) {  
               if(res.body.data=='cookie_not_found'){
                this.emitService.subscribeapiError(true); 
               }
                                                
        }
    }));
  return handler;
 }
}
